import { render, staticRenderFns } from "./SetupStatusTagsModal.vue?vue&type=template&id=f4ac76ee&scoped=true&"
import script from "./SetupStatusTagsModal.vue?vue&type=script&lang=js&"
export * from "./SetupStatusTagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ac76ee",
  null
  
)

export default component.exports